import React from 'react';
import { useParams } from 'react-router-dom';
import ReportComposeContainer from '../../containers/report/ReportComposeContainer';

/** /reports/new 또는 /reports/:id/edit - 둘 다 같은 작성 화면(한 화면, 계획 §6-2). */
const ReportComposePage = () => {
  const { id } = useParams();
  return <ReportComposeContainer rptUuid={id} />;
};

export default ReportComposePage;
